/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksnamelabel3Inputs */

const en_downloadlinksnamelabel3 = /** @type {(inputs: Downloadlinksnamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link name`)
};

const de_downloadlinksnamelabel3 = /** @type {(inputs: Downloadlinksnamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Links`)
};

/**
* | output |
* | --- |
* | "Link name" |
*
* @param {Downloadlinksnamelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksnamelabel3 = /** @type {((inputs?: Downloadlinksnamelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksnamelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksnamelabel3(inputs)
	return de_downloadlinksnamelabel3(inputs)
});
export { downloadlinksnamelabel3 as "downloadLinksNameLabel" }